var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFClothes1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 224,
    viewBox: "0 0 154 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.1858 24.7061C94.9245 13.6822 101.991 2.94094 113.015 0.679629C123.968 -1.58168 134.78 5.55558 137.041 16.5088L154 130L133 134.5L97.1858 24.7061Z",
    fill: "#F9EEED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 131L0 126.5L20.0886 16.7917C22.3499 5.7678 33.0911 -1.2988 44.115 0.962511C55.1389 3.22383 62.2056 13.9651 59.9442 24.9183L22.5 131Z",
    fill: "#F9EEED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.403 1.45734C126.583 2.58799 128.35 5.97997 127.431 9.23061L104.747 90.7086H51.6064L27.6506 10.2199C26.6612 7.03995 33.8907 1.77199 37 0.5L65 0C75 10.5 79.5 10 89 0.5L119 0L123.403 1.45734Z",
    fill: "#F9EEED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8934 68.237L34.4348 33.116",
    stroke: "#F0E3E7",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.532 68.2369L121.99 33.1158",
    stroke: "#F0E3E7",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104.393 98.8352H51.2524V90.7086H104.393V98.8352Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6404 122.191C70.1143 123.242 78.9952 129.436 77.9105 136.418L69.0974 213.902C68.2161 219.608 59.6064 224 49.3019 224C39.133 224 30.591 219.758 29.5064 214.164C27.337 203.128 25.1676 181.917 26.3201 157.366C26.8624 147.455 28.964 139.196 31.8113 132.327C34.6586 125.569 44.8276 121.102 57.2337 122.153C57.3693 122.178 57.5048 122.191 57.6404 122.191Z",
    fill: "#3F2DC8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9762 122.514C111.289 121.466 121.381 125.918 124.207 132.651C127.1 139.497 129.186 147.726 129.657 157.602C130.868 182.066 128.648 203.201 126.495 214.199C125.418 219.773 116.941 224 106.916 224C96.6213 224 88.0764 219.623 87.2018 213.937L78.455 136.728C77.4458 129.771 86.1925 123.598 98.5725 122.551C98.7071 122.551 98.8417 122.539 98.9762 122.514V122.514Z",
    fill: "#3F2DC8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M125.665 138.762L85.3851 161.869C80.7212 164.625 74.9265 164.625 70.1919 161.869L29.9122 138.762C37.4735 108.375 51.2534 98.8353 51.2534 98.8353H104.394C104.394 98.8353 117.468 109.294 125.665 138.762Z",
    fill: "#3F2DC8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1302 163.918H64.8917",
    stroke: "#291FAC",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8675 108.869C53.8675 108.869 52.8075 126.889 37.261 131.412",
    stroke: "#291FAC",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M101.355 108.869C101.355 108.869 102.415 126.889 118.032 131.412",
    stroke: "#291FAC",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFClothes1);
export default __webpack_public_path__ + "static/media/f-clothes-1.08abaa9ac9d40d9ac4e35d67923a83e7.svg";
export { ForwardRef as ReactComponent };